import React from 'react'
import { history } from '../store'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { fetchFaultsCSV } from '../actions/matrixs'

class FaultsByCustomerList extends React.Component {
  constructor(props) {
    super(props);

    this.handleDownloadPDF = this.handleDownloadPDF.bind(this)
  }

  goTo(Serial, e) {
    history.push(`/machines/${Serial}`)
  }

  handleDownloadPDF(fault) {
    const { fetchFaultsCSV } = this.props

    fetchFaultsCSV(fault.customer);
  }

  renderFaultList() {
    const { matrixs, machines } = this.props;

    // Create an object to store fault objects by customer name
    const faultsByCustomer = {};

    // Iterate over matrixs and machines to populate faultsByCustomer object
    matrixs.forEach((matrix) => {
      const serial = matrix.Serial;
      const machine = machines.find((machine) => machine.Serial === serial);

      if (machine) {
        const customer = machine.Customer;
        const customerName = customer && customer.Fullname ? customer.Fullname : '';

        matrix.Locker.forEach((lock) => {
          if (lock.FaultCode !== undefined && lock.Status === 'FL') {
            const faultCode = lock.FaultCode;
            const key = customerName;

            if (!faultsByCustomer[key]) {
              faultsByCustomer[key] = {
                customer: customerName,
                BROKEN_LOCK: 0,
                GREEN_BLOCK: 0,
                RED_BLOCK: 0,
                PINPAD_BLOCK: 0,
                DOOR_BLOCK: 0,
                PINPAD_ACTIVE: 0,
                TOTAL_FAULTS: 0,
              };
            }

            faultsByCustomer[key][faultCode]++;
            faultsByCustomer[key].TOTAL_FAULTS++;
          }
        });
      }
    });

    // Convert faultsByCustomer object to an array of fault objects
    const faultList = Object.values(faultsByCustomer);

    // Sort the faultList by customer name in alphabetical order
    faultList.sort((a, b) => a.customer.localeCompare(b.customer));

    const filter = (this.props.filterText || '').trim().toLowerCase();
    const filteredList = filter ? faultList.filter(f => (f.customer || '').toLowerCase().includes(filter)) : faultList;

    return filteredList.map((fault) => (
      <div key={fault.customer} className="list-group-item fault-card d-flex align-items-start justify-content-between">
        <div style={{ flex: 1 }}>
          <div className="font-weight-bold">{fault.customer || '—'}</div>
          <div className="text-muted small">Total: {fault.TOTAL_FAULTS}</div>
          <div className="mt-2 fault-chips" style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            <span className="badge badge-light">Pinchos: {fault.BROKEN_LOCK}</span>
            <span className="badge badge-light">Pin verde: {fault.GREEN_BLOCK}</span>
            <span className="badge badge-light">Pin rojo: {fault.RED_BLOCK}</span>
            <span className="badge badge-light">Teclado: {fault.PINPAD_BLOCK}</span>
            <span className="badge badge-light">Puerta: {fault.DOOR_BLOCK}</span>
            <span className="badge badge-light">T. encendido: {fault.PINPAD_ACTIVE}</span>
          </div>
        </div>

        <div style={{ marginLeft: 12, display: 'flex', gap: 8, alignItems: 'center' }}>
          <span className="badge fault-total-badge">Total {fault.TOTAL_FAULTS}</span>
          <button className="btn btn-vw" onClick={() => this.handleDownloadPDF(fault)}>
            <i className="fas fa-file-excel mr-1"></i>Descargar
          </button>
        </div>
      </div>
    ));
  }

  render() {
    if (!this.props.matrixs) {
      return null
    }

    return (
      <div id="content-to-pdf">
        <div className="list-group">
          {this.renderFaultList()}
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  fetchFaultsCSV: bindActionCreators(fetchFaultsCSV, dispatch)
})

export default connect(null, mapDispatchToProps)(FaultsByCustomerList);

